import { Link } from "react-router-dom";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const record = (value: unknown): Record<string, unknown> | undefined =>
  value !== null && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : undefined;

export function EchoAccentComparison({
  comparison,
  voiceRender,
  envelope,
}: {
  comparison?: unknown;
  voiceRender?: unknown;
  envelope?: Record<string, unknown>;
}) {
  const outcome = record(comparison);
  const labels = { better: "Better", same: "Same", worse: "Worse" };
  const result =
    outcome?.schema_version === "accent-comparison-outcome.v1" &&
    typeof outcome.outcome === "string" &&
    Object.hasOwn(labels, outcome.outcome) &&
    typeof outcome.parent_workload_id === "string" &&
    /^[a-zA-Z0-9_-]{1,128}$/.test(outcome.parent_workload_id)
      ? outcome
      : undefined;
  const resolved = record(envelope?.resolved_voice);
  const revision = record(
    record(voiceRender)?.voice_release_revision ??
      resolved?.voice_release_revision,
  );
  const revised =
    revision?.schema_version === "narration-voice-release-revision.v1" &&
    typeof revision.visual_release_id === "string" &&
    typeof revision.voice_release_id === "string"
      ? revision
      : undefined;
  if (!result && !revised) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Accent revision and customer comparison</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        {revised ? (
          <div className="space-y-1">
            <p>
              Narrator release deliberately revised; visual configuration
              retained.
            </p>
            <p>Visual release: {String(revised.visual_release_id)}</p>
            <p>Narrator release: {String(revised.voice_release_id)}</p>
          </div>
        ) : null}
        {result ? (
          <div className="space-y-1">
            <p className="font-medium">
              Customer says: {labels[result.outcome as keyof typeof labels]}
            </p>
            <Link
              className="underline"
              to={`/echoflicks_video_sessions/${encodeURIComponent(String(result.parent_workload_id))}/show`}
            >
              Compare with the original Echo
            </Link>
            <p className="text-muted-foreground">
              This answer is separate from the original star rating. It does not
              certify a native accent.
            </p>
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
